import * as Constants from '@/lib/constants'

export default class Thumbnailer {
  constructor() {
    this.isRetina = false
  }

  // Google https://developers.google.com/maps/documentation/maps-static/start
  getFieldThumbnailUrlFromGoogle(field, thumbnailSize = 160, isMyField = true) {
    // sample
    //https://maps.googleapis.com/maps/api/staticmap?size=640x320&maptype=hybrid&path=fillcolor:green|weight:3|color:red|35.692134,139.759854|35.691742,139.759768|35.692666,139.758674&key=AIzaSyAYyMsf2RYGCnA48OwrWtZL_IOOryXGDEo

    let geoJson = JSON.parse(field.geoJson)
    let coordinates = geoJson.features[0].geometry.coordinates[0]

    let size = 'size=' + thumbnailSize + 'x' + thumbnailSize

    let maptype = 'maptype=' + Constants.MAP_STYLE_SATELLITE
    let path = 'path='
    let fillColor = Constants.OTHERS_FIELD_THUMBNAIL_FILL_COLOR
    let strokeColor = Constants.OTHERS_FILED_CURRENT_THUMBNAIL_LINE_COLOR
    if (isMyField) {
      fillColor = Constants.MY_FIELD_THUMBNAIL_FILL_COLOR
      strokeColor = Constants.MY_FILED_CURRENT_THUMBNAIL_LINE_COLOR
    }
    path = path + 'fillcolor:' + fillColor + '|' + 'color:' + strokeColor + '|' + 'weight:2' + '|'

    let points = null
    coordinates.forEach(point => {
      if (points === null) {
        points = point[1] + ',' + point[0]
      } else {
        points = points + '|' + point[1] + ',' + point[0]
      }
    })

    path = path + points

    const key = 'key=' + Constants.GOOGLE_MAP_API_KEY
    const params = size + '&' + maptype + '&' + path + '&' + key + '&format=jpg' + '&scale=2'
    let url = 'https://maps.googleapis.com/maps/api/staticmap?' + params

    return url
  }
}
